export default "__VITE_ASSET__DTsXpVI1__"